import { useTranslation } from "react-i18next";
import useQuestionResponse from "./useQuestionResponse";
import { QuestionType } from "@pulse/api/surveyApi";
import MultipleChoiceResponse from "./Variations/MultipleChoice/MultipleChoiceResponse";
import RatingResponse from "./Variations/Rating/RatingResponse";
import TextResponse from "./Variations/Text/TextResponse";

export default function ResponseVariations() {
    const { t } = useTranslation();
    const { question } = useQuestionResponse();
    const questionType = question?.questionType;
    switch (questionType) {
        case QuestionType.RATING:
            return <RatingResponse />;
        case QuestionType.TEXT:
            return <TextResponse />;
        case QuestionType.MULTIPLE_CHOICE:
        case QuestionType.MULTI_SELECT:
            return <MultipleChoiceResponse />;
        default: {
            const _exhaustiveCheck: never = questionType;
            void _exhaustiveCheck;
            return <div>{t("responseOverview.unsupportedQuestionType")}</div>;
        }
    }
}
